import { FormEvent } from "../../components/Form"
import { ResponseCode } from "../../common/constant"
import { RouterMeta } from "../../route"
import { qweIsEmpty } from "../../common/commonHelper"

export default {
    data:function(){
        return {
            operation:"",
            contentType:"",
            contentItemId:"",
            nodeId:"",
            formEvent:FormEvent
        }
    },

    created:function(){
        this.watchRouterParams(this.$route.params);
        let self = this;
        this.$watch(
            () => this.$route.params,
            (toParams, previousParams) => {
                if(this.$route.meta.name == RouterMeta.form.name){
                    self.watchRouterParams(toParams);
                }
            }
        )
    },
    
    methods:{
        watchRouterParams:function(routerParams){
            if(qweIsEmpty(routerParams.contentItemId))
            {
                this.operation = "Create";
                this.contentType = routerParams.formId;
            }
            else{
                this.operation = "Edit";
                this.contentItemId = routerParams.contentItemId;
            }
            if(qweIsEmpty(routerParams.nodeId)){
                this.nodeId = routerParams.nodeId;
            }
        },

        initForm:function(code, Response){
            switch (code){
                case ResponseCode.Success:
                    this.showSkeleton = false;
                    break;
                case ResponseCode.NotFound:
                    this.$router.push(RouterMeta.notFound.path);
                    break;
                case ResponseCode.NetWorkError:
                    this.$router.push({name:RouterMeta.netWorkError.name,params:{ originUrl: this.$route.fullPath }});
                    break;
                case ResponseCode.UnAuthoized:
                    this.$router.push(RouterMeta.unAuthoized.path);
                    break;
                case ResponseCode.Error:
                    break;
                default:
                    break;
            }
        },

        submitForm:function(code, Response){
            switch (code){
                case ResponseCode.Success:
                    if(this.operation == "Create"){
                        this.operation = "Edit";
                        this.contentItemId = Response.ContentItemId
                    }
                    if(this.operation == "Edit"){
                        if(this.IsNextNodePIC){
                            this.nodeId = Response.NextNodeId
                        }
                    }
                    break;
                case ResponseCode.NotFound:
                    this.$router.push(RouterMeta.notFound.path);
                    break;
                case ResponseCode.NetWorkError:
                    this.$router.push({name:RouterMeta.netWorkError.name,params:{ originUrl: this.$route.fullPath }});
                    break;
                case ResponseCode.UnAuthoized:
                    this.$router.push(RouterMeta.unAuthoized.path);
                    break;
                case ResponseCode.Error:
                    break;
                default:
                    break;
            }
        }
    }
}